module.exports = __webpack_public_path__ + "img/granary4.e786a2ec.png";